module.exports = __webpack_public_path__ + "img/mergdata_digi_wireframe.e72cfd04.png";